






































































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import SoapDokterSvc from "@/services/SoapRanapDokter";
import SoapPerawatSvc from "@/services/SoapRanapPerawat";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import moment from "moment";
import Handover from "@/services/Handover";
import Readback from "@/services/Readback";
import SoapRanapDokter from "@/services/SoapRanapDokter";
import { dpjpBolehVerifSoap } from "@/utils/cpptVerif";

@Component({
  inject: {
    verifikasiTerkunciFn: {
      from: "isVerifikasiTerkunci",
      default: () => () => false
    }
  }
})
export default class CpptListContent extends Vue {
  @Prop({ default: false }) readonly readonly?: boolean;
  @Prop({ default: true }) readonly showVerifButton?: boolean;
  @Prop({ default: [] }) readonly cpptList?: Array<{
    type: string;
    data: any;
    examined_at: string;
  }>;

  verifying = false;

  verifikasiTerkunciFn!: () => boolean;

  get verifikasiTerkunci(): boolean {
    return this.verifikasiTerkunciFn();
  }

  get isDokter() {
    return ["Dokter", "Psikolog"].includes(this.stateUser.profesi);
  }

  get isPerawat() {
    return ["Perawat", "Bidan"].includes(this.stateUser.profesi);
  }

  get stateUser() {
    return userModule.user;
  }

  get registerKunjungan() {
    return RegisterKunjungan.register;
  }

  get canCopy() {
    return this.stateUser.profesi == "Dokter";
  }

  canCopyRow(item: any) {
    if (this.readonly) return false;
    if (this.canCopy) return true;

    return this.isPerawat && item && item.stat === "prwt";
  }

  get canCopySingle() {
    return this.canCopy && false;
  }

  canVerifySoap(item: any) {
    return dpjpBolehVerifSoap(
      item,
      this.stateUser,
      this.registerKunjungan?.dokter?.id
    );
  }

  canVerifyDpjp(item: any) {
    return (
      this.stateUser.id == this.registerKunjungan?.dokter?.id &&
      this.stateUser.id != item.user_id
    );
  }

  formatDate(date) {
    return date ? moment(date).format("DD-MM-YYYY HH:mm") : null;
  }

  showEditButton(item) {
    return item.user_id == this.stateUser.id;
  }

  copySoap(item) {
    if (this.canCopyRow(item)) {
      const soapItem = {
        id: null,
        subjective: item.subjective,
        objective: item.objective,
        assesment: item.assesment,
        plan: item.plan,
        instruksi: item.instruksi,
        examined_at: null,
        verified_at: null,
        copied_from_id: item.id,
        copied_edited: false,
        copied_from_label: item.examined_at
          ? ` (${this.formatDate(item.examined_at)})`
          : ""
      };

      this.$emit("copySoap", soapItem);
    } else {
      appModule.sendErrorAlert("Akun Anda belum diperkenankan untuk Copy SOAP");
    }
  }

  editSoapItem(item) {
    if (item.user.id == this.stateUser.id) {
      const soapItem = {
        ...item,
        examined_at: item.examined_at ? new Date(item.examined_at) : null,
        verified_at: item.verified_at ? new Date(item.verified_at) : null
      };

      this.$emit("editSoap", soapItem);
    } else {
      appModule.sendErrorAlert(
        "Tidak dapat mengubah SOAP yang dituliskan orang lain!"
      );
    }
  }

  editItem(item, cat) {
    let userId = item?.user_id;

    if (cat == "handover") {
      userId = item.from_user_id;
    }

    if (cat === "readback") {
      userId = item.consulting_user_id;
    }

    if (userId == this.stateUser.id) {
      let editItem = null;

      if (cat == "adime") {
        editItem = {
          ...item,
          examined_at: item.examined_at ? new Date(item.examined_at) : null,
          verified_at: item.verified_at ? new Date(item.verified_at) : null
        };
      }

      if (cat == "handover") {
        editItem = {
          ...item,
          transferred_at: item.transferred_at
            ? new Date(item.transferred_at)
            : null,
          verified_at: item.verified_at ? new Date(item.verified_at) : null
        };
      }

      if (cat == "readback") {
        editItem = {
          ...item,
          consulting_at: item.consulting_at
            ? new Date(item.consulting_at)
            : null,
          consultant_verified_at: item.consultant_verified_at
            ? new Date(item.consultant_verified_at)
            : null,
          dpjp_verified_at: item.dpjp_verified_at
            ? new Date(item.dpjp_verified_at)
            : null
        };
      }

      this.$emit(`editItem`, cat, editItem);
    } else {
      appModule.sendErrorAlert(
        "Tidak dapat mengubah catatan yang dituliskan orang lain!"
      );
    }
  }

  async verify(id, stat) {
    if (this.verifikasiTerkunci) return;
    this.confirmPrompt("Anda yakin verifikasi Catatan SOAP ini?", async () => {
      if (!this.verifying) {
        this.verifying = true;

        const SoapSvc = stat == "dr" ? SoapDokterSvc : SoapPerawatSvc;

        await SoapSvc.verify(id, {
          verificator_user_id: this.stateUser.id,
          verified_at: moment().format("YYYY-MM-DD HH:mm:ss")
        })
          .then(() => {
            this.$emit("verified");
          })
          .finally(() => {
            this.verifying = false;
          });
      }
    });
  }

  verifyReadbackByConsultant(item) {
    if (this.verifikasiTerkunci) return;
    this.confirmPrompt("Anda yakin verifikasi Readback ini?", () => {
      Readback.verifyByConsultant(item.id, {
        consultant_verified_at: moment().format("YYYY-MM-DD HH:mm:ss"),
        consultant_user_id: this.stateUser.id
      }).then(() => {
        this.$emit("readbackConsultantVerified");
      });
    });
  }

  async verifyReadbackByDpjp(item) {
    if (this.verifikasiTerkunci) return;
    this.confirmPrompt("Anda yakin verifikasi catatan ini?", async () => {
      if (!this.verifying) {
        this.verifying = true;

        await Readback.verify(item.id, {
          dpjp_user_id: this.stateUser.id,
          dpjp_verified_at: moment().format("YYYY-MM-DD HH:mm:ss")
        })
          .then(() => {
            this.$emit("readbackVerified");
          })
          .finally(() => {
            this.verifying = false;
          });
      }
    });
  }

  approveHandover(id) {
    if (this.verifikasiTerkunci) return;
    Handover.approve(id).then(() => {
      this.$emit("handoverApproved", id);
    });
  }

  subjectiveIdHovered = null;
  hoverSTimeout = undefined;
  hoverSubjective(id: number) {
    clearTimeout(this.hoverSTimeout);
    this.hoverSTimeout = setTimeout(() => {
      this.subjectiveIdHovered = id;
    }, 500);
  }
  leaveSubjective() {
    clearTimeout(this.hoverSTimeout);
    this.subjectiveIdHovered = null;
  }

  objectiveIdHovered = null;
  hoverOTimeout = undefined;
  hoverObjective(id: number) {
    clearTimeout(this.hoverOTimeout);
    this.hoverOTimeout = setTimeout(() => {
      this.objectiveIdHovered = id;
    }, 500);
  }
  leaveObjective() {
    clearTimeout(this.hoverOTimeout);
    this.objectiveIdHovered = null;
  }

  asesmenIdHovered = null;
  hoverATimeout = undefined;
  hoverAsesmen(id: number) {
    clearTimeout(this.hoverATimeout);
    this.hoverATimeout = setTimeout(() => {
      this.asesmenIdHovered = id;
    }, 500);
  }
  leaveAsesmen() {
    clearTimeout(this.hoverATimeout);
    this.asesmenIdHovered = null;
  }

  planIdHovered = null;
  hoverPTimeout = undefined;
  hoverPlan(id: number) {
    clearTimeout(this.hoverPTimeout);
    this.hoverPTimeout = setTimeout(() => {
      this.planIdHovered = id;
    }, 500);
  }
  leavePlan() {
    clearTimeout(this.hoverPTimeout);
    this.planIdHovered = null;
  }

  instruksiIdHovered = null;
  hoverInstTimeout = undefined;
  hoverInstruksi(id: number) {
    clearTimeout(this.hoverInstTimeout);
    this.hoverInstTimeout = setTimeout(() => {
      this.instruksiIdHovered = id;
    }, 500);
  }
  leaveInstruksi() {
    clearTimeout(this.hoverInstTimeout);
    this.instruksiIdHovered = null;
  }

  confirmPrompt(msg, fnCb) {
    const conf = confirm(msg);

    if (conf) {
      fnCb();
    }
  }
}
